import _ from 'lodash';

import { UUID } from '@/shared/api/types';
import { OrganizationLevelType } from '@/shared/organizations/enums';
export type PermissionValue = string | string[];
interface Rule {
  not?: boolean;
  permissions: PermissionValue;
  strategy?: 'any' | 'all';
  level?: OrganizationLevelType | OrganizationLevelType[];
}

export interface Auth {
  permissions?: Array<string>;
  level: OrganizationLevelType;
  organization: Organization;
}

export interface Organization {
  id: UUID;
  parentId: UUID;
  name: string;
  shortName: string;
  level: OrganizationLevelType;
}

export type securityConfig = Rule | Array<Rule>;

export function toArray(event: any) {
  if (event === undefined) {
    return [];
  } else if (Array.isArray(event)) {
    return event;
  } else {
    return [event];
  }
}

const checkStrategies = {
  any: (required: Array<string>, actual: Array<string>) =>
    _.intersection(required, actual).length > 0,
  all: (required: Array<string>, actual: Array<string>) =>
    _.intersection(required, actual).length === required.length,
};

export const hasPermission = (auth: Auth, config?: securityConfig) => {
  if (!config) return true;

  return toArray(config).some((rule: Rule) => {
    const { not = false, permissions, strategy = 'any', level } = rule;
    const accessList = [...(auth.permissions || [])];
    const hasLevelAccess = level ? level.includes(auth.level) : true;

    const hasPermissionsAccess = checkStrategies[strategy](
      toArray(permissions),
      accessList,
    );
    const hasAccess = hasLevelAccess && hasPermissionsAccess;

    return not ? !hasAccess : hasAccess;
  });
};
